import { useState } from 'react';
import { SearchTerm, SearchTermList } from '../../../hooks/useSearchTerms';
import { broadcastBasicSearch } from '../../../services/angular-bridge';
import { fieldContains } from '../../../utilities/searchSyntax';

interface Props {
  term: SearchTerm;
  list: SearchTermList;
  disabled: boolean;
  onUpdate: (term: SearchTerm) => void;
  onDelete: (termId: string) => void;
}

export function TermRow({ term, list, disabled, onUpdate, onDelete }: Props) {
  const [editing, setEditing] = useState(false);
  const [editedValue, setEditedValue] = useState(term.term);

  const startEdit = () => { setEditing(true); setEditedValue(term.term); };
  const cancelEdit = () => setEditing(false);
  const saveEdit = () => { setEditing(false); onUpdate({ ...term, term: editedValue }); };

  const handleView = () => {
    if (!term.tag) return;
    broadcastBasicSearch(`${fieldContains('searchTags', term.tag.id)} AND NOT ${fieldContains('systemTags', list.duplicateTag.id)}`);
  };

  return (
    <tr data-testid="admin-search-terms-term-row">
      <td>
        <div className={`form-group${term.isValid ? '' : ' has-error'}`} style={{ marginBottom: 0 }}>
          {!editing ? (
            <input
              type="text"
              className="form-control"
              value={term.term}
              data-testid="admin-search-terms-term-input"
              readOnly
              onFocus={startEdit}
              disabled={disabled}
              style={{ backgroundColor: 'white', cursor: 'text' }}
            />
          ) : (
            <div className="input-group">
              <input
                autoFocus
                type="text"
                className="form-control"
                value={editedValue}
                data-testid="admin-search-terms-term-edit-input"
                onChange={e => setEditedValue(e.target.value)}
              />
              <div className="input-group-btn">
                <button className="btn btn-primary" onClick={saveEdit} data-testid="admin-search-terms-term-save-btn">
                  <i className="fas fa-check" aria-hidden="true" />
                </button>
                <button className="btn btn-default" onClick={cancelEdit} data-testid="admin-search-terms-term-cancel-btn">
                  <i className="fas fa-times" aria-hidden="true" />
                </button>
              </div>
            </div>
          )}
          {!term.isValid && (
            <span className="help-block">
              <i className="fas fa-exclamation-triangle" aria-hidden="true" /> {term.errorMessage}
            </span>
          )}
        </div>
      </td>
      <td>
        <button
          className="btn btn-link"
          onClick={handleView}
          data-testid="admin-search-terms-term-view-btn"
          disabled={!term.tag}
          title="View search results"
        >
          view
        </button>
        {' '}
        <button
          className="btn btn-danger btn-sm"
          onClick={() => onDelete(term.id)}
          data-testid="admin-search-terms-term-delete-btn"
          disabled={disabled}
        >
          <i className="fas fa-trash" aria-hidden="true" /> Delete
        </button>
      </td>
    </tr>
  );
}
